export const getIsDownloadingProductImages = (state: Store) => state.documents.productImages.isDownloading;
export const getIsDownloadingProductImagesFailed = (state: Store) => state.documents.productImages.isFailed;
export const getDownloadingProductImagesOrderNumber = (state: Store) => state.documents.productImages.orderNumber;
